import { LinearSRGBColorSpace, WebGLRenderer } from 'three';
import * as THREE from 'three';

import PerformanceProfile from '../utils/PerformanceProfile';

// New color Management in THREE r152 - Use old color space for now
THREE.ColorManagement.enabled = false;

class Renderer extends WebGLRenderer {
    static instance?: Renderer;
    dpi: number;
    width: number;
    height: number;

    constructor(domElement?: HTMLElement, isFullScreen?) {
        const dpi = Math.min(window.devicePixelRatio, PerformanceProfile.globalProfile.maxDpr);
        super({
            antialias: false,
            alpha: true,
            stencil: false,
            powerPreference: 'high-performance',
        });

        this.outputColorSpace = LinearSRGBColorSpace;

        this.dpi = dpi;
        this.width = 0;
        this.height = 0;

        this.setClearColor(0x000000, 0);
        this.setPixelRatio(this.dpi);

        this.setFullScreen(domElement, isFullScreen);

        PerformanceProfile.onRendererUpdateProfile = this.updatePixelRatio.bind(this);
    }

    updatePixelRatio() {
        this.dpi = Math.min(window.devicePixelRatio, PerformanceProfile.globalProfile.maxDpr);
        this.setPixelRatio(this.dpi);
    }

    static getInstance(domElement?: HTMLElement, isFullScreen = true) {
        if (!Renderer.instance) Renderer.instance = new this(domElement, isFullScreen);
        return Renderer.instance;
    }

    setParent(parent: HTMLDivElement) {
        parent.appendChild(this.domElement);
    }

    setFullScreen(domElement, isFullScreen) {
        if (isFullScreen) {
            this.setSize(window.innerWidth, window.innerHeight);
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        } else {
            if (!domElement) return;
            if (domElement.clientWidth == 0) return;

            this.setSize(domElement.clientWidth, domElement.clientHeight, false);
        }
    }

    destroy() {
        this.dispose();
        delete Renderer.instance;
    }
}

export default Renderer;
